module.exports = __webpack_public_path__ + "static/media/corpu_desc_img2.daf096fd.jpg";